import { styled } from '@mui/material/styles';
import MuiSelect, { SelectProps } from '@mui/material/Select';

export const Select = styled(MuiSelect)<SelectProps>(({ theme }) => ({
  '&.MuiInputBase-root': {
    backgroundColor: '#fff',
    '& fieldset': {
      borderRadius: '5px',
      borderColor: '#E6E6E6',
      boxSizing: 'border-box',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));
